import React from 'react';

function ConfigurationIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      enableBackground="new 0 0 24 24"
    >
      <path
        d="M10.999,23c-2.935,0-5.694-1.142-7.771-3.215c-2.079-2.076-3.226-4.837-3.229-7.776c-0.003-2.938,1.14-5.702,3.216-7.781
          S8.052,1.002,10.991,1C10.994,1,10.997,1,11,1c2.935,0,5.694,1.142,7.771,3.215c2.079,2.076,3.225,4.837,3.228,7.776
          c0,0.276-0.224,0.5-0.5,0.5l0,0c-0.276,0-0.5-0.224-0.5-0.5c-0.002-2.671-1.044-5.182-2.935-7.069C16.177,3.038,13.668,2,11,2
          c-0.003,0-0.006,0-0.009,0C8.32,2.002,5.81,3.044,3.922,4.935c-1.887,1.89-2.925,4.402-2.923,7.073
          c0.002,2.671,1.045,5.182,2.935,7.069C5.822,20.962,8.331,22,10.999,22c0.003,0,0.006,0,0.009,0l0,0c0.276,0,0.5,0.224,0.5,0.5
          C11.508,22.778,11.288,22.988,10.999,23z"
      />
      <path
        d="M15.826,21.917c-0.13,0-0.26-0.05-0.357-0.15l-3.276-3.35c-0.37-0.379-0.95-0.591-1.505-0.553
          c-1.822,0.13-3.607-0.55-4.897-1.87c-1.524-1.585-2.136-3.917-1.598-6.09c0.116-0.436,0.429-0.766,0.837-0.891
          c0.447-0.125,0.896-0.004,1.215,0.322l2.134,2.181c0.194,0.198,0.606,0.2,0.805-0.001l0.971-0.993
          c0.117-0.12,0.18-0.277,0.178-0.443c-0.003-0.155-0.062-0.295-0.167-0.397L7.9,7.369c-0.314-0.322-0.43-0.753-0.315-1.182
          c0.13-0.44,0.432-0.765,0.812-0.881c2.26-0.734,4.708-0.129,6.385,1.582c1.351,1.38,2.007,3.292,1.799,5.248
          c-0.076,0.623,0.124,1.224,0.549,1.657l6.597,6.476c0.196,0.193,0.199,0.51,0.006,0.707c-0.192,0.198-0.509,0.2-0.707,0.007
          L16.421,14.5c-0.645-0.658-0.946-1.559-0.834-2.477c0.175-1.65-0.379-3.269-1.521-4.435C12.659,6.15,10.604,5.641,8.697,6.26
          C8.644,6.276,8.58,6.348,8.548,6.458C8.531,6.521,8.534,6.587,8.615,6.67l2.253,2.302c0.288,0.278,0.456,0.669,0.463,1.092
          c0.006,0.435-0.158,0.846-0.463,1.157l-0.972,0.994c-0.572,0.583-1.662,0.582-2.232,0.001l-2.135-2.182
          C5.466,9.969,5.395,9.95,5.311,9.972c-0.066,0.021-0.125,0.087-0.149,0.181c-0.454,1.833,0.061,3.808,1.347,5.145
          c1.082,1.106,2.589,1.674,4.109,1.568c0.855-0.063,1.712,0.259,2.29,0.852l3.276,3.35c0.193,0.197,0.189,0.514-0.008,0.707
          C16.078,21.87,15.952,21.917,15.826,21.917z"
      />
      <path
        d="M19.877,22c-0.13,0-0.26-0.051-0.358-0.151l-4.626-4.751c-0.192-0.198-0.188-0.514,0.01-0.707
          c0.196-0.191,0.513-0.188,0.707,0.01l4.626,4.751c0.192,0.198,0.188,0.514-0.01,0.707C20.129,21.953,20.003,22,19.877,22z"
      />
    </svg>
  );
}

export default ConfigurationIcon;
